export default "__VITE_ASSET__d8270870__"